import loadingGif from "../images/loading.png"

const Loading = () => {
    
  return (
    <img src={loadingGif} alt="Loading" className="loading" id="loading" />
  )

}

export default Loading